export function urlParser() {
  const currentUrl = window.location.pathname;
  return currentUrl.slice(1, currentUrl.length).split("/")?.[1] ?? "";
}
